

























import { Component, Vue, Watch } from 'vue-property-decorator'
@Component({
  name: 'App'
})
export default class App extends Vue {
  public transitionName: string = ''
  @Watch('$route') RoutePathChange (to: any, from: any): void {
    if (to.meta.index && from.meta.index && (to.meta.index > from.meta.index)) {
      // set name
      this.transitionName = 'slide-left'
    } else if (to.meta.index && from.meta.index && (to.meta.index < from.meta.index)) {
      this.transitionName = 'slide-right'
    } else {
      this.transitionName = ''
    }
  }

  public hintFlag = true

  handleClose () {
    this.hintFlag = !this.hintFlag
  }
}
